export type { ImageProps, MedusaImageData } from './Image'
export { default as Image } from './Image'
